import useQueryParams from 'hooks/useQueryParams'
import { useCallback } from 'react'
import { useHistory } from 'react-router'
import { useStore } from 'react-redux'
import ROUTES from 'consts/routesConsts'
import { isMobile } from 'utils/mobileUtils'
import { PatientSidebarItemKeys } from './PatientSidebar/patientSidebarConsts'

// Mobile uses route-based navigation (see Patient.mobile.jsx + AppTabs.mobile.jsx) rather
// than the desktop's `patientView` query param + PatientSwitchableView switcher. For each
// view key that maps to a tab on mobile, jump to that route directly so the user actually
// lands somewhere when (for example) the Copilot's "Go to chat" button is tapped.
const MOBILE_ROUTE_SEGMENT_BY_VIEW = {
  [PatientSidebarItemKeys.Chat]: ROUTES.PATIENT_CHAT,
  [PatientSidebarItemKeys.Notes]: ROUTES.PATIENT_NOTES,
  [PatientSidebarItemKeys.Copilot]: ROUTES.PATIENT_COPILOT
}

export default () => {
  const { addQueryParam } = useQueryParams()
  const history = useHistory()
  // Read the store via `useStore` (no subscription) so consumers of this hook —
  // `PinnedNotes`, `PatientCard`, `useAddAttachmentsToNote`, two Copilot insight widgets
  // — don't re-render every time `patient.id` changes. The patientId is only consulted
  // at the moment `selectPatientView` is called on mobile.
  const store = useStore()

  /**
   * A method to switch a patient view.
   * @param {string} view - The ID of the view to switch to. see `PatientSidebarItemKeys`.
   */
  const selectPatientView = useCallback(
    (view = '') => {
      if (isMobile()) {
        const routeSegment = MOBILE_ROUTE_SEGMENT_BY_VIEW[view]
        const patientId = store.getState().patientsReducer.patient?.id
        if (routeSegment && patientId) {
          history.push({
            pathname: `${ROUTES.PATIENTS}/${patientId}/${routeSegment}`,
            search: history.location.search
          })
          return
        }
        // No mobile-route mapping for this view (e.g. LiveCalls, OpenClarity) — fall
        // through to the query param so any desktop-only consumers still behave the
        // same way they did before.
      }
      addQueryParam({ patientView: view })
    },
    [addQueryParam, history, store]
  )

  return { selectPatientView }
}
